export default "__VITE_ASSET__cfab6591__"